export default "__VITE_ASSET__FUEE_J6B__"